import * as React from 'react';
import { L } from '../../../lib/abpUtility';
import { Button, Divider, Drawer, Progress, Row, Space, } from 'antd';

export interface IDashboardHelpProps {
    secondaryColor: string; 
    primaryColor: string;
    visible: boolean;
    onCancel: () => void;
    
}

export interface IDashboardHelpState {

}


class DashboardHelp extends React.Component<IDashboardHelpProps, IDashboardHelpState> {
    state = { 
    };

    
    render() {

        const { visible,  onCancel } = this.props;

        return (<Drawer
            onClose={onCancel}
            closeIcon={false}
            visible={visible}
            title={<Space style={{ float: 'right' }}>
                <Button>{L('Contact Suppport')}</Button>
            </Space>}
            width={350}  >
            <Divider className="font-face-gm" type="horizontal" style={{ fontSize: '2.3em', marginBottom: '0px', marginTop: '-10px' }} >
                {L('Swilab Help')}
            </Divider>
            <Row style={{ marginBottom: '0px' }}>
                <Progress
                    strokeColor={{
                        from: this.props.secondaryColor,
                        to: this.props.primaryColor,
                    }}
                    showInfo={false}
                    percent={100}
                    status="normal"
                    size={'small'}
                />
            </Row>
        </Drawer>);
    }

}

export default DashboardHelp;